import axios from "axios";
import { POST_USER_HISTORY } from "../../../services/constants";
import { getFormattedDate } from "../../share/upDater/constant";

export const handleSaveHistory = async (config) => {
  try {
    const today = getFormattedDate();
    const admin_mail = localStorage.getItem("admin_mail");

    const payload = {
      email: admin_mail,
      data: config.domain,
      date: today.date,
      month: today.month,
      year: today.year,
      type: config.type,
      location: config?.location || "0", // Default location fallback
    };

    const response = await axios.post(POST_USER_HISTORY(), payload);
  } catch (error) {
    console.error("Error saving user history:", error);
  }
};
